import { getTranslationFallback } from '../../utils/translation.utils';
import ProductFilterBase from './product-filter-base.model';
import { IProductFilterDTO, ProductFilterTypes } from './product-filter-base.model';

export default class ProductFilterSingleSelect extends ProductFilterBase {
  options = [];
  type = ProductFilterTypes.SingleSelect;

  static create(data: IProductFilterDTO): ProductFilterSingleSelect {
    return Object.assign(new ProductFilterSingleSelect(), data, {
      name: getTranslationFallback(`dcp.search.facet.${data.code}`, data.displayName ?? data.name),
      value: data.values.filter((value) => value.selected).map((value) => value.code),
      visible: data.visible && data.values.some((value) => (value.count as number) > 0),
      options: [
        {
          name: 'Show all',
          value: null,
        },
        ...(data.values
          ? data.values
              .filter((value) => (value.count ?? 0) > 0 || value.selected)
              .map((value) => ({
                count: value.count,
                name: getTranslationFallback(`dcp.search.facet.${value.code}`, value.name as string),
                value: value.code,
              }))
          : []),
      ],
    });
  }

  clone(): ProductFilterSingleSelect {
    return ProductFilterSingleSelect.create(this);
  }

  isSelected(): boolean {
    return this.value !== null;
  }

  getResetValue(): null {
    return null;
  }
}
